/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import axios from 'axios';
import { contextPathApi } from '../../settings';
import { getAccessToken } from '../../redux/features/auth/auth.service';

let canceler;

const getHeaders = () => {
  const token = getAccessToken();
  if (token) {
    return {
      'Cache-Control': 'no-cache',
      Authorization: `Bearer ${token}`,
    };
  }
  return { 'Cache-Control': 'no-cache' };
};

const cancelTokenBuilder = () =>
  new axios.CancelToken(function executor(_canceler) {
    canceler = _canceler;
  });

export default {
  getSubmission: async (submissionId) => {
    if (canceler !== undefined) {
      canceler();
    }
    return axios
      .get(`${contextPathApi}/npefiling-api/jsonschema/submissions/${submissionId}`, {
        cancelToken: cancelTokenBuilder(),
        headers: getHeaders(),
      })
      .then(response => response)
      .catch(() => Promise.resolve(null));
  },

  buildPaymentRequest: async (procedure, submissionId) => {
    if (canceler !== undefined) {
      canceler();
    }
    return axios
      .get(`${contextPathApi}/npefiling-api/${procedure}/submissions/${submissionId}/payments/request`, {
        cancelToken: cancelTokenBuilder(),
        headers: getHeaders(),
      })
      .then(response => response)
      .catch(() => Promise.resolve(null));
  },

  saveNonProvidePayment: async (procedure, submissionId) => {
    if (canceler !== undefined) {
      canceler();
    }
    return axios
      .post(
        `${contextPathApi}/npefiling-api/${procedure}/submissions/${submissionId}/payments`,
        {},
        {
          cancelToken: cancelTokenBuilder(),
          headers: getHeaders(),
        },
      )
      .then(response => response)
      .catch(() => Promise.resolve(null));
  },
};
